import {init} from '../common/init.js';
import {address} from '../common/address.js';
import {fieldDisplay} from '../common/fieldDisplay.js';
import {UserManager} from '../../lib/login/js/UserManager.js';

import { load } from 'recaptcha-v3';


var formID = 'frmSignUp';

function objectifyForm(form) { //serialize data function
	var formArray = form.serializeArray(),
		returnArray = {};
	for (var i = 0; i < formArray.length; i++) {
		returnArray[formArray[i].name] = formArray[i].value;
	}
	return returnArray;
}

function displayError(form, error) {
	var li = null;
	if (error == 'User already exists') {
		li = $('<li>')
			.append("An account for you already exists in our system.  ")
			.append($('<a>')
				//.addClass('btnForgot')
				.text('Click here')
				.on('click', function () {
					$(".btnForgot").trigger('click');
				})
			)
			.append(' to verify your email address and set your password.');
	} else {
		li = $('<li>').html(error.replace('!CONTACT!', HF_GLOBALS.contactMarkup));
		//$(".captchaLabel").addClass('error');
	}
	form.find("#errorMessage ul").append(li);
	form.find("#errorMessage").show();
	form.find("#signup").prop('disabled', false);
}

function ajaxCheckSignup(form, captchaToken, errorMessages) {
	var data = objectifyForm(form);

	$.ajax({
		data: $.extend(data, {
			userPassword: '',
			confirmPassword: '',
			action: 'checkSignup',
			captchaResponse: captchaToken
		}),
		global: false,
		dataType: 'json',
		success: function (obj) {
			var hasError = form.find('.error').length !== 0;

			if (hasError) {
				for (var i = 0; i < errorMessages.length; i++) {
					form.find("#errorMessage ul").append($('<li>').html(fieldDisplay.capFirst(errorMessages[i])));
				}
			}
			if (!UserManager.submitSignUpForm(formID, !hasError, function(error) {displayError(form, error)}) || hasError) {
				$("#errorMessage").show();
				$("#signup").prop('disabled', false);
			}

		},
		error: function (jqXHR, textStatus, errorThrown) {
			errorMessages.push(jqXHR.responseText);

			for (var i = 0; i < errorMessages.length; i++) {
				form.find("#errorMessage ul").append($('<li>').html(
					fieldDisplay.capFirst(errorMessages[i]).replace('!CONTACT!', HF_GLOBALS.contactMarkup)));
			}
			form.find("#errorMessage").show();
			form.find("#signup").prop('disabled', false);
			$("#captchaResponse").val(captchaToken);
			UserManager.submitSignUpForm(formID, false, function(error) {displayError(form, error)});
		}
	});
}

function checkSignUp(form, token) {
	let userPassword = form.find('#frmSignUp_userPassword'),
		confirmPassword = form.find('#frmSignUp_confirmPassword'),
		errorMessages = [];
	$("#signup").prop('disabled', true);

	form.find("#errorMessage").hide();
	form.find("#errorMessage ul").empty();

	form.find('.error').removeClass('error');
	form.find(".required input:not(.notrequired), .required textarea:not(.notrequired)").each(
		function () {
			if (!$(this).val()) {
				$(this).closest(".required").addClass('error');

				errorMessages.push(`${$(this).attr('title')} is required`);
			}
		});

	if (userPassword.val() != confirmPassword.val()) {
		userPassword.closest('tr').addClass('error');
		confirmPassword.closest('tr').addClass('error');
		errorMessages.push("Password fields do not match");
	}
	if (userPassword.val().length < HF_GLOBALS.minimumPasswordLength) {
		userPassword.closest('tr').addClass('error');
		confirmPassword.closest('tr').addClass('error');
		errorMessages.push("Password must be at least " +
			HF_GLOBALS.minimumPasswordLength + " characters long");
	}

	if (form.find("#telephone").val() && !form.find("#telephone").val().match(HF_GLOBALS.phoneNumberRegex)) {
		form.find("#telephone").closest('tr').addClass('error');
		errorMessages.push("Telephone number is invalid");
	}

	if (form.find("#faxNumber").val() && !form.find("#faxNumber").val().match(HF_GLOBALS.phoneNumberRegex)) {
		form.find("#faxNumber").closest('tr').addClass('error');
		errorMessages.push("Fax number is invalid");
	}
	if (form.find("#extension").val() && (!form.find("#extension").val().match(/\d{1,5}/))) {
		form.find("#extension").closest('tr').addClass('error');
		errorMessages.push("Telephone Extension must be a number");
	}

	form.find('input').each(function () {
		var inputEl = $(this),
			maxlength = inputEl.data('maxlength'),
			fieldName = inputEl.attr('title');
		if (maxlength && inputEl.val().length > maxlength) {
			inputEl.closest("tr").addClass('error');
			errorMessages.push(
				`${fieldName} is too long; it must be fewer than ${maxlength} characters long.`);
		}
	});

	ajaxCheckSignup(form, token, errorMessages);

}

window.initPage = function () {

	var form = $("#" + formID);

	$("#sameAddress").change(function () {
		if ($(this).is(':checked')) {
			$(".mailingAddress").hide();
		} else {
			$(".mailingAddress").show();
		}
	});

	$("#signup").click(function () {
		load(HF_GLOBALS.recaptchaSiteKey).then((recaptcha) => {
		  	recaptcha.execute('submit').then((token) => {
		     	checkSignUp(form, token);
		    })
		})
		
		return false;
	});

	form.submit(function (event) {
		return UserManager.submitSignUpForm(formID, true, function(error) {displayError(form, error)});
	});

};

init.init();
$(document).ready(function() {
	address.init();
	init.initPage();
});

